import React, { useState } from "react";

export default function Politique() {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow">
        <section className="bg-gradient-to-r from-blue-50 to-indigo-50 pt-20 pb-10">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Politique de Confidentialité
            </h1>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Comment nous collectons, utilisons et protégeons vos données
              personnelles.
            </p>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-4 space-y-8 max-w-4xl text-gray-700 text-justify">
            <p>
              <strong>Le site web jm-interim.com</strong> est détenu par J'M
              Intérim SAS, une agence d'emploi.
            </p>

            <p>
              Nous avons adopté cette politique de confidentialité, qui
              détermine la manière dont nous traitons les informations
              collectées par jm-interim.com, qui fournit également les raisons
              pour lesquelles nous devons collecter certaines données
              personnelles vous concernant. Par conséquent, vous devez lire
              cette politique de confidentialité avant d'utiliser le site web de
              jm-interim.com.
            </p>

            <p>
              Nous prenons soin de vos données personnelles et nous nous
              engageons à en garantir la confidentialité et la sécurité.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">
              Les informations personnelles que nous collectons :
            </h2>
            <p>
              Lorsque vous visitez le jm-interim.com, nous recueillons
              automatiquement certaines informations sur votre appareil,
              notamment des informations sur votre navigateur web, votre adresse
              IP, votre fuseau horaire et certains des cookies installés sur
              votre appareil. En outre, lorsque vous naviguez sur le site, nous
              recueillons des informations sur les pages web ou les produits
              individuels que vous consultez, sur les sites web ou les termes de
              recherche qui vous ont renvoyés au site et sur la manière dont
              vous interagissez avec le site. Nous désignons ces informations
              collectées automatiquement par le terme "informations sur les
              appareils".
            </p>
            <p>
              En outre, nous pourrions collecter les données personnelles que
              vous nous fournissez (y compris, mais sans s'y limiter, le nom, le
              prénom, l'adresse, les informations de paiement, etc.) lors de
              l'inscription afin de pouvoir exécuter le contrat.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">
              Pourquoi traitons-nous vos données ?
            </h2>
            <p>
              Notre priorité absolue est la sécurité des données des clients et,
              à ce titre, nous ne pouvons traiter que des données minimales sur
              les utilisateurs, uniquement dans la mesure où cela est absolument
              nécessaire pour maintenir le site web.
            </p>
            <p>
              Les informations collectées automatiquement sont utilisées
              uniquement pour identifier les cas potentiels d'abus et établir
              des informations statistiques concernant l'utilisation du site
              web. Ces informations statistiques ne sont pas autrement agrégées
              de manière à identifier un utilisateur particulier du système.
            </p>
            <p>
              Vous pouvez visiter le site web sans nous dire qui vous êtes ni
              révéler d'informations, par lesquelles quelqu'un pourrait vous
              identifier comme un individu spécifique et identifiable.
              Toutefois, si vous souhaitez utiliser certaines fonctionnalités du
              site web, ou si vous souhaitez recevoir notre lettre d'information
              ou fournir d'autres détails en remplissant un formulaire, vous
              pouvez nous fournir des données personnelles, telles que votre
              e-mail, votre prénom, votre nom, votre ville de résidence, votre
              organisation, votre numéro de téléphone.
            </p>
            <p>
              Vous pouvez choisir de ne pas nous fournir vos données
              personnelles, mais il se peut alors que vous ne puissiez pas
              profiter de certaines fonctionnalités du site web. Par exemple,
              vous ne pourrez pas recevoir notre bulletin d'information ou nous
              contacter directement à partir du site web. Les utilisateurs qui
              ne savent pas quelles informations sont obligatoires sont invités
              à nous contacter via communication@jm-interim.com.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">
              Vos droits :
            </h2>
            <p>
              Si vous êtes un résident européen, vous disposez des droits
              suivants :
            </p>
            <ul className="list-disc ml-6">
              <li>Le droit d'être informé.</li>
              <li>Le droit d'accès.</li>
              <li>Le droit de rectification.</li>
              <li>Le droit à l'effacement.</li>
              <li>Le droit de restreindre le traitement.</li>
              <li>Le droit à la portabilité des données.</li>
              <li>Le droit d'opposition.</li>
              <li>
                Les droits relatifs à la prise de décision automatisée et au
                profilage.
              </li>
            </ul>
            <p>
              Si vous souhaitez exercer ces droits, veuillez nous contacter via
              les coordonnées ci-dessous.
            </p>
            <p>
              En outre, si vous êtes un résident européen, nous notons que nous
              traitons vos informations afin d'exécuter les contrats que nous
              pourrions avoir avec vous (par exemple, si vous passez une
              commande par le biais du site), ou autrement pour poursuivre nos
              intérêts commerciaux légitimes énumérés ci-dessus. En outre,
              veuillez noter que vos informations pourraient être transférées en
              dehors de l'Europe, y compris au Canada et aux États-Unis.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">
              Liens vers d'autres sites web :
            </h2>
            <p>
              Notre site web peut contenir des liens vers d'autres sites web qui
              ne sont pas détenus ou contrôlés par nous. Sachez que nous ne
              sommes pas responsables de ces autres sites web ou des pratiques
              de confidentialité des tiers. Nous vous encourageons à être
              attentif lorsque vous quittez notre site web et à lire les
              déclarations de confidentialité de chaque site web susceptible de
              collecter des informations personnelles.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">
              Sécurité de l'information :
            </h2>
            <p>
              Nous sécurisons les informations que vous fournissez sur des
              serveurs informatiques dans un environnement contrôlé et sécurisé,
              protégé contre tout accès, utilisation ou divulgation non
              autorisés. Nous conservons des garanties administratives,
              techniques et physiques raisonnables pour nous protéger contre
              tout accès, utilisation, modification et divulgation non autorisés
              des données personnelles sous notre contrôle. Toutefois, aucune
              transmission de données sur Internet ou sur un réseau sans fil ne
              peut être garantie.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">
              Divulgation légale :
            </h2>
            <p>
              Nous divulguerons toute information que nous collectons, utilisons
              ou recevons si la loi l'exige ou l'autorise, par exemple pour nous
              conformer à une citation à comparaître ou à une procédure
              judiciaire similaire, et lorsque nous pensons de bonne foi que la
              divulgation est nécessaire pour protéger nos droits, votre
              sécurité ou celle d'autrui, enquêter sur une fraude ou répondre à
              une demande du gouvernement.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">
              Informations de contact :
            </h2>
            <p>
              Si vous souhaitez nous contacter pour comprendre davantage la
              présente politique ou si vous souhaitez nous contacter concernant
              toute question relative aux droits individuels et à vos
              informations personnelles, vous pouvez envoyer un courriel à :{" "}
              <a
                href="mailto:communication@jm-interim.com"
                className="text-blue-600 underline"
              >
                communication@jm-interim.com
              </a>
            </p>
          </div>
        </section>
      </main>
    </div>
  );
}
